var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.984 9h5.531l-5.531-5.484V9zm3 5.016V12H8.015v2.016h7.969zm0 3.984v-2.016H8.015V18h7.969zM14.016 2.016l6 6v12c0 .531-.203.992-.609 1.383-.406.39-.875.586-1.406.586h-12c-.531 0-1-.196-1.406-.586-.406-.391-.609-.852-.609-1.383l.047-16.031c0-.532.195-.993.586-1.383.39-.391.852-.586 1.383-.586h8.016-.002z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.553538a7ef9358aa104f23414a4ca1e3.svg";
export { ForwardRef as ReactComponent };